// Vuex user module mutations types
export const FILL_DETAILS = 'FILL_DETAILS';
